module.exports = __webpack_public_path__ + "static/media/email.26c8ac63.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Container/components/Footer/img/email.svg
// module id = 144
// module chunks = 0